import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M9.75 5.25a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75ZM4.296 18.905A.761.761 0 0 1 4 19a.78.78 0 0 1-.53-.25l-1.53-1.42a.75.75 0 0 1 0-1.06.76.76 0 0 1 1.06 0l.86.85 2.62-3.51a.73.73 0 0 1 1.288.625.74.74 0 0 1-.128.265l-3.11 4.2a.761.761 0 0 1-.234.206Zm.004-8.001A.72.72 0 0 1 4 11a.74.74 0 0 1-.47-.18L2 9.41A.75.75 0 0 1 3 8.3l.88.85 2.61-3.53a.751.751 0 0 1 1.21.89l-3.17 4.18a.72.72 0 0 1-.23.214ZM9 12a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 12Zm.75 5.25a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H9.75Z';
const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextListCheckmarkIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'textListCheckmark')) as IconWithRender;

TextListCheckmarkIcon.displayName = 'TextListCheckmarkIcon';
TextListCheckmarkIcon.propTypes = Icon.propTypes;
TextListCheckmarkIcon.renderIcon = (props) => (
  <TextListCheckmarkIcon {...props} />
);
export default TextListCheckmarkIcon;
